import { Injectable } from '@angular/core';

@Injectable()
export class Toast {
  currentToasts: any[] = [
  ];

  private presentToast(type: string, text: string) {
    setTimeout(() => {
      this.currentToasts.unshift({
        type: type,
        content: text
      });
    }, 50);

  }

  success(text: string) {
    this.presentToast('success', text);
  }

  error(text: string) {
    this.presentToast('error', text);
  }

  announcement(text: string) {
    this.presentToast('announcement', text);
  }

  removeToast(toast: any) {
    let self = this;
    setTimeout(() => {
      let i = self.currentToasts.indexOf(toast);
      if (i > -1) this.currentToasts.splice(i, 1);
    }, 400);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/toast/toast.service.ts